import { forwardRef } from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect x={1} y={1} width={14} height={14} rx={3} stroke="currentColor" strokeWidth={2} /><path d="M15 5H1.5" stroke="currentColor" strokeWidth={2} /><rect x={4} y={8} width={3} height={3} rx={1} fill="currentColor" /><rect x={9} y={8} width={3} height={3} rx={1} fill="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;